module.exports = __webpack_public_path__ + "static/media/Sec-1_2677HomePlayer_CN.74a5a005.webp";